var map = {
	"./Book-Search-Engine.png": 37,
	"./Code-Refactoring.png": 38,
	"./Coding-Portfolio.png": 39,
	"./ECommerce-Backend.png": 40,
	"./Employee-Tracker.png": 41,
	"./Forever-Paws.png": 42,
	"./Javascript-Quiz.png": 43,
	"./Job-Journey.png": 44,
	"./MVC-Tech-Blog.png": 45,
	"./Meal-PreApp.png": 46,
	"./Note-Taker.png": 47,
	"./PWA-Text-Editor.png": 48,
	"./Password-Generator.png": 49,
	"./Professional-Readme.png": 50,
	"./REGEX-Tutorial.png": 51,
	"./Redux-Store.png": 52,
	"./SN-API.png": 53,
	"./SVG-Logo-Maker.png": 54,
	"./Study-Guide.png": 55,
	"./Weather-Dashboard.png": 56,
	"./Workday-Scheduler.png": 57
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36;